export const arBtnStyles = (theme) => ({
    button_container_default: {
        width: '100%',
        display: 'flex',
        justifyContent: props => props.mobile_ar_button.button_position,
        '& a, & button': {
            ...theme.default_button,
            boxShadow: 'none',
            borderRadius: 12,
            justifyContent: 'center',
            textDecoration: 'none',
            background: props => props.mobile_ar_button.button_color,
            color: props => props.mobile_ar_button.button_text_color,
            fontFamily: props => props.default_text_font,
            width: 'auto',
            margin: 0,
            textTransform: 'none',
            
        },
    },
    ar_text: {
        lineHeight: 1,
        paddingTop: 2,
    },
    button_container_billboard: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        '& a, & button': {
            ...theme.default_button,
            justifyContent: 'space-around',
            borderRadius: 12,
            flexDirection: 'column !important',
            //background: props => props.mobile_ar_button.button_color,
            background: '#00344E', // Force override to remove branding
            color: props => props.mobile_ar_button.button_text_color,
            fontFamily: props => props.default_text_font,
            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
            margin: 0,
            textDecoration: 'none',
            width: '100%',
            '& span': {
                fontSize: '1.1em',
                //color: props => props.mobile_ar_button.button_text_color,
                color: '#fff', // Force override to remove branding
                textTransform: 'uppercase'
            }
        },
    },
    button_container_tabs: {
        top: '100%',
        marginRight: '2rem',
        '& a, & button': {
            ...theme.default_button,
            boxShadow: 'none',
            borderRadius: 12,
            justifyContent: 'center',
            //background: props => props.viewer_button.button_color,
            //background: '#00344E',
            //backgroundColor: 'transparent',
            //border: '1px solid #ccc',
            //color: props => props.viewer_button.button_text_color,
            color: '#ffffff',
            fontFamily: props => props.default_text_font,
            width: '100%',
            padding: '7px 0 0 22px',
            background: '#ececec',
            borderTopLeftRadius: 45,
            borderBottomLeftRadius: 45,
        },
        '& span': {
            color: 'rgba(0, 0, 0, 0.87) !important',
            fontSize: '0.95rem !important',
            fontWeight: '500 !important',
            marginTop: -3,

        },
    },
    button_ar_tabs: {
        width: 18, 
        marginTop: -4,
        //fill: props => props.viewer_button.button_color,
        fill: '#fff',
        position: 'relative',
        zIndex: 2,
    },
    tabs_icon_container: {
        position: 'relative',
        marginLeft: 18,
        '&::after': {
            content: `''`,
            position: 'absolute',
            width: 37,
            left: -10,
            top: -10,
            height: 34,
            background: '#00344E', // Force override to remove branding
            //background: props => props.viewer_button.button_color,
            zIndex: 1,
            display: 'block',
            borderRadius: '50%',
        }
    },
    button_ar_default: {
        width: 23,
        marginRight: 10,
        pointerEvents: 'none'
    },
    button_ar_rotate: {
        width: 50,
    },
    button_ar_icon_billboard: {
        maxWidth: '43px !important',
        fill: "#ffffff",
    },
    button_ar_default_png: {
        width: '100%',
        maxWidth: 23,
        marginRight: 10,
    },
    btn_from_modal: {
        ...theme.default_button,
        textTransform: 'uppercase',
        padding: '10px 15px 10px',
        justifyContent: 'center',
        width: '100%',
        background: props => props.viewer_button.button_color,
        color: props => props.viewer_button.button_text_color,
        fontFamily: props => props.default_text_font,
        margin: 'auto'
    },
    loaderSpinner: {
        border: '2px solid #ffffff',
        borderTopColor: props => props.viewer_button.button_color,
        borderTop: '2px solid',
        borderRadius: '50%',
        width: 16,
        height: 16,
        animation: '$spin .6s linear infinite'
    },
    iconContainer: {
        display: 'flex',
        '& a, & button': {
            transition: 'all 0.5s ease',
            opacity: 1,
            padding: 0,
            border: 'none',
            outline: 'none',
            background: 'none',
            cursor: 'pointer',
            '&:hover': {
                opacity: .5
            },
        }
    },
    // rotate_360_icon: {
    //     width: 60
    // },
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
    }
});
